module.exports = __webpack_public_path__ + "img/responsive hospitium-11.c08e215e.jpg";